export default __webpack_public_path__ + "src/assets/completed.b877ba63edbf33f89ea78c52e4799bd9.svg";